<script setup lang="ts" generic="MM">
import FormField from '@/components/input/FormField.vue'
import { Validation, ValidationArgs } from '@vuelidate/core'

const props = defineProps<{
  modelValue?: boolean
  validation?: Validation<ValidationArgs, MM>
}>()

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
}>()

defineOptions({
  inheritAttrs: false,
})
</script>

<template>
  <form-field :validation="props.validation">
    <v-checkbox
      v-bind="$attrs"
      :model-value="props.modelValue"
      hide-details
      @update:model-value="(val) => emit('update:modelValue', val ?? false)"
    />
  </form-field>
</template>
